export default {
  computed: {
    queryParams () {
      return this.$route.query
    },
    isSearchPage () {
      return this.$route.name === 'search-page'
    }
  },
  methods: {
    updateQuery (query, replace = true) {
      query = this.updatePageParam(query)
      if (replace) {
        this.$router.replace({ query })
        return
      }
      this.$router.push({ query })
    },
    updatePageParam (query) {
      return (!query.page || this.isSearchPage)
        ? query
        : { ...query,
          'page': query.page + 1
        }
    }
  }
}
